import React from "react";
import "./index.scss";
import { Config } from "./contexts/Config";
import { Auth } from "./contexts/Auth";
import { AppRouter } from "./AppRouter";
import { Filters } from "./contexts/Filters";

export const App: React.FC = () => {
  return (
    <Config>
      <Auth>
        <Filters>
          <AppRouter />
        </Filters>
      </Auth>
    </Config>
  );
};
